module.exports = __webpack_public_path__ + "static/media/MediBiro_png.7167169c.png";